import { gql } from "@apollo/client";

export const GET_CLINICAL_CONSTRAINT_TEMPLATES_FOR_EPISODE_QUERY = gql(`
  query GetClinicalConstraintTemplatesForEpisode($serviceLineId: Int!)
  @permission(requires: managePatients)
  {
    clinicalConstraintTemplate(
      where: {
        serviceLineId: { eq: $serviceLineId }
        deleted: { eq: false }
      }
      orderBy: { name: { direction: asc, priority: 1 } }
    ) {
      id
      serviceLineId
      name
      description
      rruleFreq
      durationDays
      firstVisitTypeId
      firstVisitServiceIds
      firstVisitDuration
      requirements(
        where: { deleted: { eq: false } }
        orderBy: { id: { direction: asc, priority: 1 } }
      ) {
        id
        templateId
        visitTypeId
        duration
        rruleInterval
        rruleByweekday
        earliestStartTime
        latestStartTime
        minTimeFromLastVisit
        maxTimeFromLastVisit
        serviceIds
      }
    }
  }
`);

export const GET_CLINICAL_CONSTRAINT_TEMPLATES_FOR_CONFIG_QUERY = gql(`
  query GetClinicalConstraintTemplatesForConfig
  @permission(requires: manageOrgConfig)
  {
    clinicalConstraintTemplate(
      where: { deleted: { eq: false } }
      orderBy: { name: { direction: asc, priority: 1 } }
    ) {
      id
      serviceLineId
      name
      description
      rruleFreq
      durationDays
      updatedAt
      firstVisitTypeId
      firstVisitServiceIds
      firstVisitDuration
      requirements(
        where: { deleted: { eq: false } }
        orderBy: { id: { direction: asc, priority: 1 } }
      ) {
        id
        templateId
        visitTypeId
        duration
        rruleInterval
        rruleByweekday
        earliestStartTime
        latestStartTime
        minTimeFromLastVisit
        maxTimeFromLastVisit
        serviceIds
      }
    }
  }
`);

export const CREATE_CLINICAL_CONSTRAINT_TEMPLATE_MUTATION = gql(`
  mutation CreateClinicalConstraintTemplate(
    $serviceLineId: Int!
    $name: String!
    $description: String
    $rruleFreq: String!
    $durationDays: Int!
    $firstVisitTypeId: Int
    $firstVisitServiceIds: [Int!]
    $firstVisitDuration: Int
    $requirements: [ClinicalConstraintTemplateRequirementInput!]!
  )
  @permission(requires: manageOrgConfig)
  {
    createClinicalConstraintTemplate(
      serviceLineId: $serviceLineId
      name: $name
      description: $description
      rruleFreq: $rruleFreq
      durationDays: $durationDays
      firstVisitTypeId: $firstVisitTypeId
      firstVisitServiceIds: $firstVisitServiceIds
      firstVisitDuration: $firstVisitDuration
      requirements: $requirements
    ) {
      id
      serviceLineId
      name
      description
      rruleFreq
      durationDays
      updatedAt
    }
  }
`);

export const UPDATE_CLINICAL_CONSTRAINT_TEMPLATE_MUTATION = gql(`
  mutation UpdateClinicalConstraintTemplate(
    $id: Int!
    $name: String
    $description: String
    $rruleFreq: String
    $durationDays: Int
    $firstVisitTypeId: Int
    $firstVisitServiceIds: [Int!]
    $firstVisitDuration: Int
    $requirements: [ClinicalConstraintTemplateRequirementUpsertInput!]!
  )
  @permission(requires: manageOrgConfig)
  {
    updateClinicalConstraintTemplate(
      id: $id
      name: $name
      description: $description
      rruleFreq: $rruleFreq
      durationDays: $durationDays
      firstVisitTypeId: $firstVisitTypeId
      firstVisitServiceIds: $firstVisitServiceIds
      firstVisitDuration: $firstVisitDuration
      requirements: $requirements
    ) {
      id
      updatedAt
    }
  }
`);

export const DELETE_CLINICAL_CONSTRAINT_TEMPLATE_MUTATION = gql(`
  mutation DeleteClinicalConstraintTemplate($id: Int!)
  @permission(requires: manageOrgConfig)
  {
    deleteClinicalConstraintTemplate(id: $id) {
      id
      deleted
      updatedAt
    }
  }
`);
